import { ClientEntitiesTable } from "../components/ClientEntitiesTable.js";

export const ClientEntitiesPage = () => {
  return <ClientEntitiesTable />;
};
